import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as advance from "./style.module.scss";
import { AdvanceNoRocket } from "../../../../AdvanceNoRocket";
import { ExpertLicenses } from "../../../../ExpertLicenses";
import { Licenses } from "../../../../Licenses";
import { SmiAboutUs } from "../../../../SmiAboutUs";
export const Advance = () => {
  return (
    <>
      <AdvanceNoRocket
        sectionName={`${advance.advance__norocket} ${main.sec}`}
        ttlName={advance.advance__title}
        colCustomize={`col ${advance.advance__norocketCol}`}
        yearsTxt={"занимаемся развитием личной эффективности"}
        pplCountTxt={"человек посетили наши пробные уроки и\u00A0семинары"}
        pplCoursesTxt={"человек прошли наши полные программы"}
      />
      <section className={`${advance.advance__experts} ${main.sec}`}>
        <div className="container">
          <h2 className={advance.advance__title}>Нас ценят эксперты образования</h2>
          <ExpertLicenses/>
        </div>
      </section>
      <section className={`${advance.advance__licenses} ${main.sec}`}>
        <div className="container">
          <h2 className={advance.advance__title}>Мы развиваем образование</h2>
          <Licenses/>
        </div>
      </section>
      <SmiAboutUs
        sectionName={main.sec}
        ttlName={advance.advance__title}
      />
    </>
  );
};
